/**
 * 廠商幣種 → 平台幣種 對應表。
 * 廠商以 key 幣種計價，平台以 value 幣種的錢包遊玩與顯示；新增對應只需在此加一筆。
 */
export const PROVIDER_TO_PLATFORM_CURRENCY: Readonly<Record<string, string>> = {
  USD: 'USDT',
};

/**
 * 將廠商幣種轉為對應的平台幣種，無對應則原樣返回
 *
 * @param providerCurrency 廠商幣種代碼
 * @returns 平台幣種代碼
 */
export function toPlatformCurrency(providerCurrency: string): string {
  return PROVIDER_TO_PLATFORM_CURRENCY[providerCurrency] ?? providerCurrency;
}
